/** @returns {string|null} German error message or null if valid. */
export const validatePersonNames = (firstName, lastName) => {
  const fn = String(firstName || "").trim();
  const ln = String(lastName || "").trim();
  const messages = [];

  if (!fn) messages.push("Bitte gib deinen Vornamen an.");
  else if (fn.length < 2) messages.push("Der Vorname muss mindestens 2 Zeichen lang sein.");
  else if (fn.length > 50) messages.push("Der Vorname darf höchstens 50 Zeichen lang sein.");

  if (!ln) messages.push("Bitte gib deinen Nachnamen an.");
  else if (ln.length < 2) messages.push("Der Nachname muss mindestens 2 Zeichen lang sein.");
  else if (ln.length > 50) messages.push("Der Nachname darf höchstens 50 Zeichen lang sein.");

  return messages.length ? messages.join(" ") : null;
};
